export default function CGetStarted() {
  return <h2>C Get Started</h2>;
}
